<template>
  <b-modal
    id="decommissionVehicleModal"
    size="md"
    content-class="sub-menu-bg-blue-transparent dcv-modal"
    title="Decommission Vehicle"
    hide-footer
    no-fade
    header-close-variant="light"
  >
    <div class="dcv-body" v-if="vehicle">

      <!-- Warning strip -->
      <div class="dcv-warning-strip">
        <fa :icon="['fas', 'exclamation-triangle']" class="dcv-warning-icon" />
        <span>This will mark the vehicle as inactive.</span>
      </div>

      <!-- Warning strip -->
      <div class="dcv-warning-strip">
        <fa :icon="['fas', 'exclamation-triangle']" class="dcv-warning-icon" />
        <span>This will automatically decommission any scanners associated with this vehicle.</span>
      </div>

      <!-- Vehicle info card -->
      <div class="dcv-vehicle-card">
        <div class="dcv-vehicle-row">
          <span class="dcv-label">Vehicle</span>
          <span class="dcv-value">{{ vehicle.vehicle_name }}</span>
        </div>
        <div class="dcv-vehicle-row">
          <span class="dcv-label">Region</span>
          <span class="dcv-value">{{ vehicle.region }}</span>
        </div>
      </div>

      <!-- Confirmation text -->
      <p class="dcv-confirm-text">
        Vehicle <b class="dcv-highlight">{{ vehicle.vehicle_name }}</b> will be set to
        <b class="dcv-highlight dcv-highlight--danger">INACTIVE</b>.
        It can be re-commissioned later from the Inactive vehicles list.
      </p>

      <!-- Actions -->
      <div class="dcv-actions">
        <b-button class="dcv-confirm-btn" @click="submit()">
          Confirm Decommission
        </b-button>
      </div>

    </div>
  </b-modal>
</template>

<script>
import axios from 'axios'
export default {
  name: 'MMP_DPR_DecommissionVehicle',
  props: ['vehicle', 'user'],
  methods: {
    submit() {
      if (sessionStorage.token) {
        axios.put(process.env.API_LOCATION + '/api/dpr/decommissionVehicle', {
          id: this.vehicle.id,
          user: this.user.id,
          region: this.vehicle.region
        }, {
          headers: { 'x-auth-token': sessionStorage.token }
        }).then(response => {
          const content = response.data
          if (content.errors) {
            this.$bvToast.toast(content.errors, {
              title: 'Decommission Error',
              variant: 'danger',
              toaster: 'b-toaster-top-right'
            })
          } else {
            this.$bvToast.toast(`${this.vehicle.vehicle_name} has been decommissioned.`, {
              title: 'Vehicle Decommissioned',
              variant: 'success',
              autoHideDelay: 5000,
              toaster: 'b-toaster-top-right'
            })
            this.$emit('refresh')
            this.$bvModal.hide('decommissionVehicleModal')
          }
        }).catch(error => console.log(error))
      } else {
        console.log('No User Token')
      }
    }
  }
}
</script>

<style scoped>
.dcv-body {
  padding: 4px 0 8px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

/* Warning strip */
.dcv-warning-strip {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 13px;
  background: rgba(224, 90, 90, 0.1);
  border: 1px solid rgba(224, 90, 90, 0.3);
  border-left: 3px solid #e05a5a;
  border-radius: 6px;
  font-size: 13px;
  color: #e05a5a;
}
.dcv-warning-icon {
  color: #e05a5a;
  flex-shrink: 0;
}

/* Vehicle info card */
.dcv-vehicle-card {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 14px;
  background: rgba(6, 60, 109, 0.04);
  border: 1px solid rgba(6, 60, 109, 0.12);
  border-radius: 6px;
}
.dcv-vehicle-row {
  display: flex;
  align-items: baseline;
  gap: 12px;
}
.dcv-label {
  font-size: 11px;
  font-weight: 600;
  color: rgba(6, 60, 109, 0.6);
  letter-spacing: 0.07em;
  text-transform: uppercase;
  min-width: 60px;
}
.dcv-value {
  font-size: 13.5px;
  color: #063c6d;
  font-weight: 500;
}

/* Confirmation text */
.dcv-confirm-text {
  font-size: 13px;
  color: rgba(6, 60, 109, 0.7);
  line-height: 1.65;
  margin: 0;
}
.dcv-highlight {
  color: #063c6d;
  font-weight: 600;
}
.dcv-highlight--danger {
  color: #e05a5a;
}

/* Actions */
.dcv-actions {
  display: flex;
  justify-content: center;
  padding-top: 4px;
}
.dcv-confirm-btn {
  background: rgba(224, 90, 90, 0.18) !important;
  border: 1px solid rgba(224, 90, 90, 0.45) !important;
  color: #e05a5a !important;
  font-weight: 600;
  padding: 8px 24px;
  border-radius: 6px;
  transition: background 0.15s;
  box-shadow: none !important;
}
.dcv-confirm-btn:hover {
  background: rgba(224, 90, 90, 0.3) !important;
}
</style>
